import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "../UI/Dialog";
import {  CardDescription } from "../UI/Card";
import { Button } from "../UI/Button";
import { useTranslation } from 'react-i18next';


const ConfirmationDialog = ({ isOpen, onClose, onConfirm, info }) => {
      const { t } = useTranslation();
    
    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent onInteractOutside={(event) => {
                event.preventDefault();
            }} className="max-w-md">
                <DialogHeader>
                    {info?.action && <DialogTitle>
                        <div className="flex items-center text-left ">
                            <CardDescription className="text-black">{info?.action}</CardDescription> {info?.name &&<> <CardDescription className="mx-2">{"•"}</CardDescription> <CardDescription>{info?.name.toLowerCase()}</CardDescription></>}
                        </div>
                    </DialogTitle>}
                </DialogHeader>
                <div className="space-y-6 my-4">
                    <div className="space-y-2">
                        <div className="flex items-center dialogue-form-row">
                            <div className="dialogue-form-label">
                                <CardDescription className="text-black">{info?.message}</CardDescription>
                            </div>
                        </div>

                    </div>
                    <DialogFooter>
                        <Button className="focus:outline-none" onClick={() => onConfirm(info?.id)}>
                            {t("yesBtn")}
                        </Button >
                        <Button className="border border-gray-300 bg-white  text-black font-medium py-3 rounded-lg transition hover:bg-white focus:outline-none" onClick={onClose}>
                            {t("no")}
                        </Button>
                    </DialogFooter>
                </div>

            </DialogContent>
        </Dialog>
    );
}
export default ConfirmationDialog;
